import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Injector, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';


@Component({
  selector: 'request-hours-changes-details',
  templateUrl: './request-hours-changes-details.html',
  styleUrls: ['./request-hours-changes-details.scss'],
})
export class RequestHoursChangesDetails extends BaseComponent implements OnInit {
  public changeHoursRequest: any = {};
  public affiliation: any = {};
  public currentAffiliation: any = {};
  public type: string = '';
  public specialtyName: any = '';
  public unchangedHours: any;
  public healthcareserviceId: string = '';

  constructor(
    private injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private affiliationService: PractitionerOrganizationAffiliationService
  ) {
    super(injector);
  }

  async ngOnInit() {
    this.type = this.currentUser.type;
    this.changeHoursRequest = this.data.param.request;
    this.affiliation = this.data.param.affiliation;
    this.healthcareserviceId = this.data.param.request.specialtyId;
    await this.getAffiliationDetails(this.affiliation.affiliation_id);
  }

  async getAffiliationDetails(affiliation_id: string) {
    this.affiliationService.showByAffiliationId(affiliation_id).subscribe({
      next: (resAffiliation: any) => {
        this.affiliation = resAffiliation;
        this.currentAffiliation = resAffiliation;
        this.unchangedHours = resAffiliation.specialty[0].practitionerHours;
        this.getSpecialtyName();
      },
      error: (err) => {
        console.log('Affiliation error', err);
      },
    });
  }

  get hasDefinedHours(): boolean {
    return Array.isArray(this.unchangedHours) && this.unchangedHours.some((d: any) => d?.active && Array.isArray(d?.hours) && d.hours.length > 0);
  }

  getSpecialtyName() {
    this.specialtyName = this.currentAffiliation.specialty.filter((specialty: any) => specialty.id === this.changeHoursRequest.specialtyId);
    return this.specialtyName.length > 0 ? this.specialtyName[0].display ?? 'Undefined' : 'Undefined';
  }

  cancelRequest() {
    const req = { ...this.changeHoursRequest, status: 'refused' };
    const data = { ...this.currentAffiliation, changeRequest: [req] };
    this.affiliationService.refuseHoursChange(this.affiliation.affiliation_id, req.id, data).subscribe({
      next: () => {
        this.getAffiliationDetails(this.affiliation.affiliation_id)

        this.openSnackBar("Mudança de Horário recusada com sucesso", "success")
        this.changeHoursRequest.status = "recused"

      },
      error: (err: HttpErrorResponse) => {

        this.messageError = err.error.message || err.message 

        this.openSnackBar(`Não foi possível aprovar a mudança de horário. ${this.messageError}`, "error")
          
      }
    });
  }

  approveRequest() {
    const changeRequest = { ...this.changeHoursRequest, status: 'accepted' };
    const data = { ...this.currentAffiliation, changeRequest: [changeRequest] };

    this.affiliationService.approveHoursChanges(this.affiliation.affiliation_id, changeRequest.changeRequestId, data).subscribe({
      next: () => {
        this.getAffiliationDetails(this.affiliation.affiliation_id);
        this.openSnackBar("Mudança de Horário aprovada com sucesso", "success")

        this.changeHoursRequest.status = "accepted"
      },
      error: (err: HttpErrorResponse) => {
         
        this.messageError = err.error.error || err.message
        this.openSnackBar(`Não foi possível aprovar a mudança de horário. ${this.messageError}`, "error")
      }
    });
  }

  transformStatusText(status: string) {
    switch (status) {
      case 'accepted':
        return 'Aprovado';
      case 'pending':
        return 'Aprovação Pendente';
      default:
        return 'Recusado';
    }
  }
}
